import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { trainingVideos } from '../trainingData';

function PathDetailPage({ path, progress, t, onBack, onOpenVideo }) {
  const videos = path.videoIds.map((id) => trainingVideos.find((video) => video.id === id));
  const completed = videos.filter((video) => progress[video.id]?.completedAt).length;
  const percent = Math.round((completed / videos.length) * 100);

  return (
    <motion.div className="page-content path-detail-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <button type="button" className="back-button" onClick={onBack}>
        <SafeIcon icon={FiIcons.FiArrowLeft} /> {t.backToTraining}
      </button>
      <section className="path-hero">
        <div className="path-ring" style={{ '--path-progress': `${percent * 3.6}deg` }}>
          <span>{percent}%</span>
        </div>
        <div>
          <span className="eyebrow">{t.learningPaths}</span>
          <h1>{path.title}</h1>
          <p>{path.description}</p>
          <strong>{completed} / {videos.length} {t.videosCompleted}</strong>
        </div>
      </section>
      <div className="path-detail-heading">
        <h2>{t.pathVideos}</h2>
        <span>{t.pathProgress}: {percent}%</span>
      </div>
      <div className="path-video-list">
        {videos.map((video, index) => {
          const previousComplete = index === 0 || Boolean(progress[videos[index - 1].id]?.completedAt);
          const itemProgress = progress[video.id]?.percentWatched || 0;
          const isComplete = Boolean(progress[video.id]?.completedAt);
          const locked = !previousComplete && !isComplete;

          return (
            <article className={`path-video-item ${locked ? 'locked' : ''}`} key={video.id}>
              <span className="path-video-number">
                {isComplete ? <SafeIcon icon={FiIcons.FiCheck} /> : index + 1}
              </span>
              <div className="path-video-info">
                <span className="training-category">{t.lesson} {index + 1} · {video.category}</span>
                <h3>{video.title}</h3>
                <span>{Math.ceil(video.durationSeconds / 60)} {t.minutes} · {video.language}</span>
              </div>
              {locked ? (
                <span className="locked-label" title={t.locked}><SafeIcon icon={FiIcons.FiLock} /></span>
              ) : (
                <button type="button" className="path-play" onClick={() => onOpenVideo(video.id)}>
                  {isComplete ? <SafeIcon icon={FiIcons.FiCheckCircle} /> : itemProgress ? `${itemProgress}%` : <SafeIcon icon={FiIcons.FiPlay} />}
                </button>
              )}
            </article>
          );
        })}
      </div>
    </motion.div>
  );
}

export default PathDetailPage;